import { AccountInfo } from "@azure/msal-browser";
import React from "react";
import { useUserPhoto } from "../hooks/useUserPhoto";

interface UserPhotoProps {
  account: AccountInfo;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-8 h-8 text-xs",
  md: "w-9 h-9 text-sm",
  lg: "w-10 h-10 text-sm",
};

const getInitials = (name?: string) => {
  if (!name) return "U";
  const parts = name.split(" ");
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }
  return name.charAt(0).toUpperCase();
};

const UserPhoto: React.FC<UserPhotoProps> = ({
  account,
  size = "md",
  className = "",
}) => {
  const { data: photoUrl } = useUserPhoto(account);

  return (
    <div className={`avatar placeholder ${className}`}>
      <div
        className={`bg-primary-focus text-primary-content rounded-full overflow-hidden ${sizeClasses[size]}`}
      >
        {photoUrl ? (
          <img
            src={photoUrl}
            alt={account.name || "Utilisateur"}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="font-semibold">{getInitials(account.name)}</span>
        )}
      </div>
    </div>
  );
};

export default UserPhoto;
